import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Resuelve el white-label de la organizacion dueña de este dominio (si la hay)
 * una vez al cargar la app. `GET /api/org/branding/resolve` es publico (sin
 * auth) y cacheado 60s en el servidor, asi que no hay problema en llamarlo
 * antes de saber si hay sesion.
 *
 * Si la org tiene branding, se aplican appName/logoUrl como overrides visibles
 * y primaryColor/accentColor como overrides de --accent/--link sobre tokens.css
 * (el resto de la paleta del design system se mantiene: el white-label no
 * reescribe todo el tema, solo la marca).
 */
export function useBranding() {
  const [branding, setBranding] = useState({ default: true });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/org/branding/resolve', { params: { host: window.location.host } })
      .then((res) => {
        const data = res.data || { default: true };
        setBranding(data);
        if (!data.default) {
          if (data.primaryColor) document.documentElement.style.setProperty('--accent', data.primaryColor);
          if (data.accentColor) document.documentElement.style.setProperty('--link', data.accentColor);
        }
      })
      .catch(() => setBranding({ default: true }))
      .finally(() => setLoading(false));
  }, []);

  return { branding, loading };
}

export default useBranding;
